import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog'
import ForgotPasswordPrompt from './ForgotPasswordPrompt';
import Checkbox from 'material-ui/Checkbox';
import TosDialog from './TosDialog';

class Login extends React.Component {

  state = {
    tosOpen: false,
    emailError: ""
  }

  constructor(props) {
    super(props);
  }

  render() {
    let email = this.refs && this.refs.email ? this.refs.email.getValue() : "your email address";
    let emailErrorText = this.state.emailError;
    if (this.props.errors && this.props.errors.email){
      emailErrorText = (emailErrorText.length > 0) ? emailErrorText + " : " + this.props.errors.email : this.props.errors.email;
    }
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.props.onRequestClose}
      />,
      <RaisedButton label="Login" primary={true} disabled={this.props.submitting} onClick={this.handleSubmit} />
    ];
    return (
      <Dialog open={this.props.open} title="Login" onRequestClose={this.props.onRequestClose} actions={actions}>
        <TextField
          autoFocus
          ref="email"
          floatingLabelText="Email"
          defaultValue={this.props.email}
          type="text"
          errorText={emailErrorText}
        />
        <br />
        <TextField
          ref="password"
          floatingLabelText="Password"
          type="password"
          defaultValue={this.props.password}
          onKeyDown={this.handleKeyDown}
          errorText={this.props.errors ? this.props.errors.password : null}
        />
        <br />
        <br />
        <Checkbox ref="agree" defaultChecked={true} style={{display: 'inline-block', width: 220}} label={<span>I agree to the FishPath</span>} /><a style={{position: 'relative', top: -7, left: -13}} href="javascript:;" onClick={() => this.setState({tosOpen: true})}>Terms of Service</a>
        <br />
        <FlatButton label="Forgot Password?" onClick={this.forgotPassword} />
        { this.props.error ? <div style={{color: "red", marginTop: 20}}>{this.props.error}</div> : null}
        <ForgotPasswordPrompt open={this.props.inForgotPasswordFlow} submitting={this.props.submitting} onSubmit={this.props.handleForgotPasswordCode} error={this.props.error} email={email} />
        { this.state.tosOpen && <TosDialog open={true} dismissable={true} onDismiss={() => this.setState({tosOpen: false})} /> }
      </Dialog>
    )
  }

  handleSubmit = () => {
    if (!this.refs.agree.state.switched) {
      alert("You must agree to the FishPath Terms of Service to proceed");
    } else {
      if (this.props.onSubmit) {
        this.props.onSubmit({
          email: this.refs.email.getValue(),
          password: this.refs.password.getValue()
        })
      }
    }
  }

  forgotPassword = () => {
    if(this.refs.email && this.refs.email.getValue()){
      if (this.props.onForgotPassword) {
        this.props.onForgotPassword(this.refs.email.getValue())
      }
    } else {
      this.setState({emailError: "Email Required"})
    }
  }

  handleKeyDown = (e, key) => {
    if (e.keyCode === 13) {
      this.handleSubmit()
    }
  }

}

Login.defaultProps = {
  open: true
}

export default Login
